import {EPermissions, ScreenProp} from 'src/app/models'

type TKeys = 'WO_OUTGOING' | 'WO_OUTGOING_LIST' | 'WO_OUTGOING_DETAIL' | 'WO_OUTGOING_ADD'

export const WoOutgoingScreen: Record<TKeys, ScreenProp> = {
  WO_OUTGOING: {
    PATH: '/work-order/outgoing',
    TITLE: 'WO Terkirim',
    TITLE_ALT: 'WO Terkirim',
  },
  WO_OUTGOING_LIST: {
    PATH: '/work-order/outgoing/list',
    TITLE: 'WO Terkirim',
    TITLE_ALT: 'Terkirim',
    PERMISSION: [EPermissions.WORK_ORDER_OUTGOING_READ],
  },
  WO_OUTGOING_DETAIL: {
    PATH: '/work-order/outgoing/detail/:id',
    TITLE: 'Detail WO Terkirim',
    TITLE_ALT: 'Detail WO Terkirim',
    PERMISSION: [EPermissions.WORK_ORDER_OUTGOING_READ],
  },
  WO_OUTGOING_ADD: {
    PATH: '/work-order/outgoing/add',
    TITLE: 'Buat',
    TITLE_ALT: 'Buat',
    PERMISSION: [EPermissions.WORK_ORDER_OUTGOING_CREATE],
  },
}
